
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Testimonial </h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm club section-banner-bg-1">
    <div class="container">
        <div class="sec-title text-center">
            <h2><span>Testimonial </span></h2>
        </div>
    </div>
    <div  class="row row-cols-lg-3 row-cols-md-2 row-cols-1 justify-content-sm-center mt-3 p-0 m-0">
        <div  class="col">
            <h6 class="fw-bold mb-4">Forever Lata : A Musical Tribute to Bharat Ratna Lata Mangeshkar -
                Bhandara</h6>
            <div  class="img-area">
                <div  class="overlay-color"></div>
                <img  rel="preload" src="assets/images/new-theme/foreverlata.png" alt="Our vision" loading="lazy" class="img-fluid" height="700px">
                <div  class="lightBox--gallery text-center">
                    <ul  class="video-gallery" lg-uid="lg0">
                        <li  data-src="https://www.youtube.com/embed/3dJnSjbzEEo" class="video aos-init aos-animate">
                            <a  href="https://www.youtube.com/embed/3dJnSjbzEEo" class="ripple-effect">
                                <div  class="light-gallery-poster-">
                                    <img  rel="preload" src="https://rgicdn.s3.ap-south-1.amazonaws.com/srwc/images/play-button.avif" alt="GHRSCF">
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

</section>
